module.exports = __webpack_public_path__ + "img/trunk_10x2_z16.75cb1aa4.svg";